<template>
  <div :class="sensors.length == 1 ? 'feed-data-one' : 'feed-data'" @click.stop="openFeedDetails">
    <AnimadePlaceHolder v-if="dataFeed.length == 0" height="70px" width="100%"  borderRadius="4px"/>
    <div
      v-else
      class="progress-bar progress"
      style="width: 100%; padding: 0; margin: 0 2px; border-radius: 4px"
      :class="`${smartFeedColor(dataFeed[0])}`"
    >
      <div class="container-information-td feed-data-info-col">
        <p class="product-information-line">
          <span 
            class="feed-data-name"
            :title="dataFeed[0].message != undefined ? 'SEM DADOS' : dataFeed[0].name"
          >
            {{ dataFeed[0].message != undefined ? feed.name : dataFeed[0].name }}
          </span>
        </p>
        <div class="feed-data-name-container" v-if="dataFeed[0].message == undefined">
          <p class="product-information-line">
            <span>{{ dataFeed[0].message != undefined ? 'SEM DADOS' : computedLevel }}</span>
          </p>
          <p class="product-information-line">
            <span v-if="dataFeed[0].message != undefined">
              SEM DADOS
            </span>
            <span v-else-if="isOldData(dataFeed[0].datetime)" :id="smartFeedColor(dataFeed[0], true)" class="sem-dados-warning">
              {{ displayDateOrSemDados(dataFeed[0].datetime) }}
            </span>
            <span v-else>
              {{ formatDate(dataFeed[0].datetime) }}
            </span>
          </p>
        </div>
        <div class="feed-data-name-container" v-else>
          <p class="product-information-line">
            <span>SEM DADOS</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import  Tooltip  from '../components/Tooltip.vue';
import { apiRoutes } from "../utils/api"
import { normalizeSiloLastProfile } from '../utils/siloLevelToKg'
import AnimadePlaceHolder from './AnimadePlaceHolder.vue'
import { format, parseISO } from 'date-fns'

export default {
  name: "SensorsFeed",
  components: {
    AnimadePlaceHolder,
    // Tooltip, // Eliminado porque ya no se usa
  },
  data() {
    return {
      dataFeedFromFetch:[],
      loading: true
    }
  },
  props: ["sensors", "indexBarn", 'barn', 'batch', 'feed', 'useInformedWeight'],
  methods:{
    openFeedDetails() {
      if (this.dataFeed.length === 0) return;

      this.$store.commit("setBarnTarget", this.barn)
      this.$store.commit("setBatchTarget", this.batch[0] == undefined ? null : this.batch[0])
      this.$router.push({
        path: '/batch-details/smart-feed-v3',
        query: {
          silo: this.feed?.silo,
          sensor: this.feed?.pk ?? this.feed?.sensor
        }
      })
      this.$emit('select-silo', this.feed)
    },
    formatDate (date) {
      if (date) {
          return format(parseISO(date), 'dd-MM-yyyy HH:mm')
      } else {
          return 'SEM DADOS'
      }
    },
    displayDateOrSemDados(date) {
      if (!date) return 'SEM DADOS';
      const now = new Date();
      const dateObj = new Date(date);
      const diffTime = now - dateObj;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 7) {
        return `SEM DADOS há ${diffDays} dias`;
      }
      return this.formatDate(date);
    },
    isOldData(date) {
      if (!date) return false;
      const now = new Date();
      const dateObj = new Date(date);
      const diffTime = now - dateObj;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      return diffDays > 7;
    },
   smartFeedColor(feed, colorText) {
      if (colorText) {
        if (feed.message !== undefined) return 'feed-disabled-text'
        if (this.batch[0]?.date_departure != null) return 'feed-disabled-text'
        if (feed.last_hour_level > 30) {
          return 'peso-feed-bom-text'
        }
        if (feed.last_hour_level > 15) {
          return 'peso-feed-medio-text'
        }
        if (feed.message) {
          return 'feed-disabled-text'
        }
        return 'peso-feed-ruim-text'
      }
      if ( this.batch?.message) {
        if (feed.last_hour_level > 30) {
          return 'peso-feed-bom'
        }
        if (feed.last_hour_level > 15) {
          return 'peso-feed-medio'
        }
        if (feed.message) {
          return 'feed-disabled'
        }
        return 'peso-feed-ruim'
      } 
      if (feed.message !== undefined) return 'feed-disabled'
      if (this.batch[0]?.date_departure != null) return 'feed-disabled'
      if (feed.last_hour_level > 30) {
        return 'peso-feed-bom'
      }
      if (feed.last_hour_level > 15) {
        return 'peso-feed-medio'
      }
      return 'peso-feed-ruim'
    },
    async getDataFeed() {
      try {
        const siloPk = this.feed?.silo?.pk ?? this.feed?.silo?.id ?? this.feed?.silo
        const barnPk = this.barn?.pk ?? this.barn?.id ?? null
        if (!siloPk) {
          this.dataFeedFromFetch.push({
            message: { detail: 'Silo não informado' },
            name: this.feed?.name,
            silo: this.feed?.silo,
            sensor: this.feed?.pk
          });
        } else {
          const url_to_fetch = apiRoutes.siloLastProfileBySilo(siloPk, undefined, undefined, true);
          const response = await fetch(url_to_fetch, {
            headers: this.$store.getters.getHeader
          });
          const profile = normalizeSiloLastProfile(await response.json());

          // Salvar no store (cache Home) o último perfil por silo
          if (barnPk != null) {
            this.$store.commit('setSiloDataHomeByBarn', {
              barnPk,
              siloPk,
              data: profile,
              lastUpdated: new Date().toISOString()
            })
          }

          // Mapear para o shape antigo usado pela Home (FeedData)
          const mappedForHome = profile?.detail
            ? {
                message: profile,
                name: this.feed?.name,
                silo: this.feed?.silo,
                sensor: this.feed?.pk
              }
            : {
                ...profile,
                name: profile?.silo_name || this.feed?.name,
                silo: siloPk,
                sensor: this.feed?.pk,
                last_hour_level: Number(profile?.level ?? 0),
                datetime: profile?.last_updated || profile?.datetime_fetched || profile?.datetime || null
              }

          this.dataFeedFromFetch.push(mappedForHome);
        }

        const allDataFeed = {
          barn: this.barn,
          batch: this.batch[0],
          sensor: this.sensors,
          data:this.dataFeedFromFetch
        }

        this.$store.commit('setSensorsListFeed', allDataFeed)
      } catch (error) {
        console.log(error)
      }
    }
  },
  computed:{
    dataFeedBySensor() {
      const listbyBarn = this.$store.getters.getSensorsListFeed.filter((feed)=>{
        return feed.barn.pk == this.barn.pk
      })
      if (listbyBarn[0]) {
          return listbyBarn[0].data.find((feed)=>{
            return feed.sensor == this.feed.pk
        })
      } else {
        return undefined
      }
    },
    dataFeed() {
      if (this.dataFeedBySensor) return [this.dataFeedBySensor]
      return this.dataFeedFromFetch ?? []
    },
    informedMaxWeight() {
      return this.dataFeed[0]?.informed_max_weight
    },
    computedLevel() {
      if (!this.dataFeed[0]?.last_hour_level && this.dataFeed[0]?.last_hour_level !== 0) return "Sem Nível"
      const level = this.useInformedWeight ? (this.dataFeed[0].last_hour_level * 0.9).toFixed(2) : this.dataFeed[0].last_hour_level
      return `${level}%`
    }
  },
  async created() {
    if (!this.dataFeedBySensor) {
      await this.getDataFeed()
    }
  }
};

</script>

<style scoped>
.cursor{
  cursor: not-allowed;
}

.progress {
  border-radius: 0;
  height: 70px;
  background-color: #f4f4f4;
  font-weight: bold;
  font-size: 14px;
}

.progress-bar {
  text-align: left;
  padding-left: 18px;
}


a {text-decoration: none;}
.peso-atual-acima .progress-bar {background: #415430;}
a .peso-atual-acima .progress-bar:hover {background: #273619;}
.peso-atual-bom .progress-bar {background: #a1cd7b;}
a .peso-atual-bom .progress-bar:hover {background: #5e7d42;}
.peso-atual-medio .progress-bar {background: #e2bf65;}
a .peso-atual-medio .progress-bar:hover {background: #c59e3a;}
.peso-atual-ruim .progress-bar {background: #a94949;}
a .peso-atual-ruim .progress-bar:hover {background: #952323;}
.no-sensor .progress-bar {background:  #f2f2f2; color: grey;}
a .no-sensor .progress-bar:hover {background: #cfcfcf;}
.disable .progress-bar {background:  #adadad;}
a .disable .progress-bar:hover {background: grey;}

.feed-data-wrapper {
  display: flex;
  width: 100%;
  padding: 0;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

@media screen and (max-width: 991px) {
  .feed-data-wrapper {
    flex-direction: column;
    gap: 0;
  }
}

.feed-data { 
  flex: 1 1 calc(50% - 5px); 
  max-width: calc(50% - 5px); 
  transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1); 
}

.feed-data-one {
  flex: 1 1 calc(100% - 10px); 
  max-width: calc(100% - 10px); 
  transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1); 
}

.fonteSenlote{
  margin: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  font-size: 12px
}

.container-information-td.feed-data-info-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
}
.product-information-line {
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  color: inherit;
  line-height: 1.5;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  text-align: center;
}
.product-information-line span {
  font-weight: 600;
  margin-left: 4px;
}
.feed-data-name {
  display: inline-block;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
.sem-dados-warning {
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-block;
  font-size: 14px;
  margin-left: 4px;
}

.sem-dados-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 40px;
}

.sem-dados-container .sem-dados-warning {
  font-size: 14px;
  margin-left: 0;
  text-align: center;
}

.imgIcon{
  width: 20px;
  margin: 4px;
  margin-right: 8px;

}

.feed-data {
  width: -moz-available;
  width: -webkit-fill-available;
}

.peso-feed-acima {background: #415430;}
.peso-feed-acima:hover {background: #273619;}
.peso-feed-bom {background: #a1cd7b;}
.peso-feed-bom:hover {background: #5e7d42;}
.peso-feed-medio {background: #e2bf65;}
.peso-feed-medio:hover {background: #c59e3a;}
.peso-feed-ruim {background: #c25757;}
.peso-feed-ruim:hover {background: #952323;}
.feed-disabled {background:  #adadad;}
.feed-disabled:hover {background: grey;}

.product-information {
  margin: 0px;
  padding: 0px;
  font-size: 12px
}

.product-information span{
  margin: 0px;
  margin-right: 4px;
  padding: 0px;
  font-size: 12px;
  font-weight: 700;
}


#peso-feed-bom-text{
  color: #003d03;
}

#peso-feed-medio-text {
  color:#3d3900;
}

#feed-disabled-text {
  color: white
}

#peso-feed-ruim-text{
  color:#3d0000; 
}

.card-button {
  cursor: pointer;
}

@media screen and (min-width: 991px) {
  .imgIcon{
    display: none;
  }
}

@media screen and (max-width: 991px) {
  .product-information {
    font-size: 12px
  }
  .product-information span{
    font-size: 12px
  }
}
</style>